<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Potansiyel Müşteri Kaybı",
      items: [
        { text: "ANASAYFA", href: "/" },
        { text: "POTANSİYEL MÜŞTERİ KAYBI", active: true }
      ],
      kayip: { suresi_gecmis: 0, yedi_gun: 0, pasif: 0, kesilen: 0, ariza: 0, liste: [] }
    };
  },
  mounted() {
    this.$http.get('/dashboard/kayiplar').then(res => {
      this.kayip = Object.assign(this.kayip, res.data || {});
    }).catch(() => {});
  },
  methods: {
    durum(row) {
      if (row.neden) return row.neden;
      if (Number(row.status) === 2) return 'Süreden pasif';
      if (Number(row.gun) < 0) return 'Süresi geçmiş';
      return row.gun + ' gün kaldı';
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="kayip-stats mb-3">
      <div class="kayip-stat"><span>Süresi geçmiş</span><strong>{{ kayip.suresi_gecmis }}</strong></div>
      <div class="kayip-stat"><span>7 gün içinde</span><strong>{{ kayip.yedi_gun }}</strong></div>
      <div class="kayip-stat"><span>Süreden pasif</span><strong>{{ kayip.pasif }}</strong></div>
      <div class="kayip-stat"><span>Sık kesilen</span><strong>{{ kayip.kesilen }}</strong></div>
      <div class="kayip-stat"><span>Çok arıza</span><strong>{{ kayip.ariza }}</strong></div>
    </div>
    <div class="card">
      <div class="card-body">
        <p class="text-muted">2026 bitişli en eski aboneler</p>
        <table class="table mb-0">
          <thead><tr><th>Kullanıcı</th><th>İsim</th><th>Tarife</th><th>Bitiş</th><th>Durum</th></tr></thead>
          <tbody>
            <tr v-for="(row, i) in kayip.liste" :key="i">
              <td>{{ row.username }}</td>
              <td>{{ row.fullname }}</td>
              <td>{{ row.tariff }}</td>
              <td>{{ row.bitis }}</td>
              <td>{{ durum(row) }}</td>
            </tr>
            <tr v-if="!kayip.liste.length"><td colspan="5" class="text-muted">Kayıt yok</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.kayip-stats { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 8px; }
.kayip-stat { background: #fff; border-radius: 12px; padding: 10px 12px; box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08); }
.kayip-stat span { display: block; font-size: 12px; color: #64748b; }
.kayip-stat strong { font-size: 20px; }
</style>
